// import { emailRegex, phoneRegex } from "../../components/common/Helpers/Validations";
// import * as yup from "yup";

// import React from "react";
// import { Col, Container, Row } from "reactstrap";
// import { Box } from "@mui/material";
// import { PageHeader } from "../../components/common/PageHeader/PageHeader";
// import { CMForm } from "../../components/common/Form/CMForm";
// import { editLab, getByLabId } from "./LabServices";
// import { cityDropdown } from "../City/CityServices";

// export const formFields: any = [
//     {
//         label: "Name",
//         type: 'text',
//         name: 'name',
//         placeholder: 'Enter Name',
//         options:cityDropdown
//     },
//     {
//         label: "Lab Diagnosis",
//         type: 'text',
//         name: 'lan_diagnosis',
//         placeholder: 'Select Lab Diagonsis',
//         options:cityDropdown
//     },
//     {
//         label: "Lab Details",
//         type: 'text',
//         name: 'lab_details',
//         placeholder: 'Enter Lab Details',
//     }
// ]

// export const validationSchema = yup.object({
//     name: yup.string().ensure().required("Name is required!").min(3, 'To short!'),
//     lab_diagnosis: yup.object().required("Lab Diagnosis is required!"),
//     lab_details: yup.string().ensure().required("Lab Details is required!").min(3, 'To short!'),
// });

// export const LabEdit = () => {

//     return (
//         <React.Fragment>
//             <div className="page-content">
//                 <Container fluid>

//                     <Row>
//                         <Col lg={12}>
//                             <Box component="div" sx={{ mt: 2 }}>
//                                 <PageHeader header="Edit Lab" />
//                                 <CMForm
//                                     validationSchema={validationSchema}
//                                     formFields={formFields}
//                                     addService={editLab}
//                                     listPageKey='LAB_LIST'
//                                     type="edit"
//                                     detailService={getByLabId}
//                                 />
//                             </Box>
//                         </Col>
//                     </Row>

//                 </Container>
//             </div>
//         </React.Fragment>
//     )
// }


import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addLab} from "./LabServices";
import { formFields, validationSchema } from "./LabSchema";
import LabTable from "../../components/common/Model/LabTable";

export const LabEdit = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                                    <Box component="div" sx={{ mt: 2 }}>
                                        <PageHeader header="Edit Lab" />
                                        {/* <CMForm
                                            validationSchema={validationSchema}
                                            formFields={formFields}
                                            addService={addLab}
                                            listPageKey='LAB_LIST'
                                        />  */}
                                        <LabTable EDIT="EDITLAB"/>
                                    </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
